module.exports = __webpack_public_path__ + "assets/img/37@3x.2a3bb0e9.png";